import { EnhancedLander } from '@editor/types/lander';

// Default Lander Analytics Stats
const defaultLanderAnalyticsStats = () => ({
  visits: {},
  // uniqueVisits: {},
  clicks: {},
  leads: {},
  conversions: {},
});

// Default Lander Analytics Reports
const defaultLanderAnalyticsReports = () => ({
  deviceType: {
    title: 'Device Type',
    items: {},
  },
  connectionISP: {
    title: 'ISP',
    items: {},
  },
  locationCountry: {
    title: 'Countries',
    items: {},
  },
  locationCity: {
    title: 'Cities',
    items: {},
  },
});

// Default Lander Settings
const defaultLanderSettings = () => ({
  general: {
    title: '',
    language: 'en',
    favicon: '',
  },
  seo: {
    keywords: '',
    description: '',
  },
  customCode: {
    head: '',
    body: '',
  },
  tracking: {
    facebookPixel: '',
    googleTagManager: '',
    googleAnalytics: '',
    ringbaCampaignId: '',
    retreaverCampaignKey: '',
    tiktokPixel: '',
    snapchatPixel: '',
    taboolaPixel: ''
  },
  dynamicTokens: {
    tokens: false,
  },
  conversions: {
    visits: false,
    forms: false,
    links: false
  },
  leads: {
    skipLeadSave: false,
    trustedForm: {
      enabled: false,
    },
    jornaya: {
      enabled: false,
      accountCode: '',
      campaignKey: ''
    },
    recaptchaV2: {
      enabled: false,
      siteKey: '',
      size: 'normal',
    },
    turnstile: {
      enabled: false,
      siteKey: '',
    },
    clickflare: {
      enabled: false,
    },
    recaptchaV3: {
      enabled: false,
      siteKey: '',
      secretKey: ''
    },
    googlePlaces: {
      enabled: false,
      apiKey: ''
    }
  },
  fonts: {
    fonts: '',
  },
});

export type DefaultLanderSettings = ReturnType<typeof defaultLanderSettings>;

// Lander Published URL
const landerUrl = ({ domain, path, indexFile }: { domain: string; path: string; indexFile: string }) => {
  domain = domain.replace(/^https?:\/\//, '');
  path = path === '/' ? '' : path;
  indexFile = !indexFile || indexFile === 'index.html' ? '' : `/${indexFile}`;

  return `${domain}${path}${indexFile}`;
};

// Map Lander
const mapLander = ((lander: EnhancedLander) => {
  const { masterVariant: { image, indexFile }, domain, path } = lander;

  return {
    ...lander,
    type: 'lander',
    image,
    publishedUrl: lander.published ? landerUrl({ domain: domain?.name || '', path, indexFile: indexFile || '' }) : '',
  };
});

export {
  defaultLanderAnalyticsStats,
  defaultLanderAnalyticsReports,
  defaultLanderSettings,
  landerUrl,
  mapLander
};
